import React, { useEffect, useRef, useState } from "react";
import styles from "./contactLinks.module.scss";
import { Divider, Dropdown, Menu, Modal, Tooltip } from "antd";
import { URInput } from "../../../../shared/widgets/input";
import ChatLike from "../../../chat/chatWidgets/chatLike";
import { useSelector } from "react-redux";

import store from "../../../../context/store/store";
import {
  contactwindowDetails, LoginState,
  initialStateModel, chatwindowDetails
} from "../../../../models/model";
import { ChatService } from "../../../../base/chatService";
import { Cookie, getcontactDetail, getGroupDateFormat, getTimeFormat, getTooltipTime, urlify } from "../../../../base/utils";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { Types } from "../../../../context/action/action";
import { URChatLeftSkeleton } from "../../../../shared/widgets/skeletonLoading/chatLeftSkeleton";
import linkNoFound from "../../../../styles/images/empty_states/links_empty_state.svg";
import NoContent from "../../../../shared/widgets/noContent";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";
import Lottie from "lottie-react";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import { SocketChatService } from "../../../../base/socketChatService";
import { generateChatID, likeCommonFunction, paginationContactSave, saveChatCommonFunction, userInfo } from "../../../../base/socketChatService/utils";
import moment from "moment";
import _ from "lodash";
import { HighlightInner } from "../../rightsidebar/highlight";
//import { useHistory } from "react-router-dom";
import ChatLeftInfo from "../../../chat/chatWidgets/chatLeftInfo";
type LinkPageState = {
  searchLink: any;
  filterKey: string;
  isSearch: any;
  limit: number;
  searchKey: string;
  AuthorList: any;
  isCalender: boolean;
  noteLoader: boolean;
  searchNotes: any;
  deleteModelOpen: boolean;
  deletedData: any;
  tempLinkList: any;
  linkListArr: any;
  isVisible: boolean;
  searchText: string;
}

export default function ContactLinksChat(props: any) {

  let { contactWindowDetails, contactLinkList, isContactLink,
    isLinkChatLoad }: contactwindowDetails =
    store.getState().contactWindowReducer;


  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  //const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const [linkList, setlinkList] = useState<LinkPageState>({
    searchLink: [],
    filterKey: "",
    isSearch: [],
    limit: 10, searchKey: '', AuthorList: [],
    isCalender: false, isVisible: false, searchText: "",
    noteLoader: false, searchNotes: [], deleteModelOpen: false, deletedData: "", tempLinkList: [], linkListArr: []
  });

  let { isMySpace }: chatwindowDetails = store.getState().chatWindowReducer;
  const socketChat = useRef<any>(null);
  useEffect(() => {

    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
    let arr: any = [];
    if (contactWindowDetails?.team_id && !(_.isUndefined(contactWindowDetails.teammembersdetails))) {
      arr = [...contactWindowDetails.teammembersdetails]
    } else {
      arr = [userdetails, contactWindowDetails]
    }


    let response: any = search(linkList.searchKey);
    let result: any = _(response)
      .groupBy((o: any) => (o.timestamp &&
        moment(o.timestamp).format('DD MMM YYYY')))
      .map((contacts: any, letter: any) => ({ letter, contacts }))
      .value();
    setlinkList({ ...linkList, linkListArr: result, tempLinkList: response, AuthorList: arr, isSearch: arr });
  }, [contactLinkList?.length])

  useEffect(() => {
    if (isMySpace && window.location.pathname === "/chats") {
      let linkListMyspace = {
        offset: 40, orderType: 0, id: ""
      };
      socketChat.current.getmySpaceLinkList(linkListMyspace);
    }
    else {
      if (window.location.pathname === "/contacts") {
        let linkListInput = {
          chatId: contactWindowDetails.chatId, offset: 15, orderType: 0, id: ""
        };
        socketChat.current.linkChatList(linkListInput);
      }
    }

  }, [contactWindowDetails]);

  const handleScroll = (e: any) => {
    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if (bottom) {
      if (isMySpace && window.location.pathname === "/chats") {
        let linkListMyspace = {
          offset: 30, orderType: 0,
          id: Array.isArray(contactLinkList) && contactLinkList.length > 0 ? contactLinkList[contactLinkList.length - 1].id : ''
        };
        socketChat.current.getmySpaceLinkList(linkListMyspace);
        paginationContactSave("fromLink");
      }
      else {
        if (contactLinkList.length > 10) {
          let linkListInput = {
            chatId: contactWindowDetails.chatId, offset: 20, orderType: 0,
            id: contactLinkList.length >= 0 ? contactLinkList[contactLinkList.length - 1].id : ''
          };
          socketChat.current.linkChatList(linkListInput);
          paginationContactSave("fromLink");
        }

      }
    }
  };

  // const openLink = (url: any) => {
  //   if (!url.includes("http")) url = "https://" + url;
  //   window.open(url);
  // };

  const copy = (data: any) => {
    let toast: string = ("Success! Link copied");
    navigator.clipboard.writeText(data.message.body);
    toastInformation(toast, "success");
  }

  const deleteChat = (data: any) => {
    socketChat.current.deleteForEveryone(data.id);
    let index: any = contactLinkList.findIndex((e: any) => e.id === data.id);
    if (index !== -1) {
      contactLinkList.splice(index, 1);
    }
    store.dispatch({
      type: Types.CONTACT_LINK_LIST,
      payload: {
        isContactLink: true,
        contactLinkList: contactLinkList
      }
    });
    let toast: string = ("Selected Link deleted for all")
    toastInformation(toast, 'success');
    setlinkList({ ...linkList, deleteModelOpen: false })
  };


  const searchKey = (e: any) => {
    let response: any = search(e.target.value);
    let result: any = _(response)
      .groupBy((o: any) => (o.timestamp &&
        moment(o.timestamp).format('DD MMM YYYY')))
      .map((contacts: any, letter: any) => ({ letter, contacts }))
      .value();
    setlinkList({ ...linkList, searchKey: e.target.value, linkListArr: result })
  }
  const search = (str: any) => {
    let searchText = str.toLowerCase();
    return _.filter(contactLinkList, function (data: any) {
      let saveMessageBody = data.message.messageType === "TEXT" ? (data.message.body.trim() || "") : "";;
      let sender = data.fromDetails?.caller_id || '';
      let toTeam = (data.toDetails?.caller_id ? data.toDetails?.caller_id : data.toDetails?.team_name) || '';
      let Datesearch = moment(data.timestamp).format('DD MMM YYYY') || '';
      return (((saveMessageBody).toLowerCase()).includes(searchText) ||
        (sender).toLowerCase().includes(searchText) || (toTeam).toLowerCase().includes(searchText) ||
        (Datesearch.toString()).toLowerCase().includes(searchText));
    });

  };
  const AuthorFilter = (list: any) => {
    const response: any = _.filter(linkList.tempLinkList, ((item) => {
      return item?.from === list.sip_login_id.toString();
    }));
    let result: any = _(response)
      .groupBy((o: any) => (o.timestamp &&
        moment(o.timestamp).format('DD MMM YYYY')))
      .map((contacts: any, letter: any) => ({ letter, contacts }))
      .value();

    setlinkList({ ...linkList, linkListArr: result, filterKey: "All", isVisible: false });
  };

  const searchMember = (e: any) => {
    let searchText = e.target.value.toLowerCase();
    let response = _.filter(linkList.isSearch, ((list: any) => {
      let caller_id = list?.caller_id || "";
      return ((caller_id?.toLowerCase()).includes(searchText));
    }));
    setlinkList({ ...linkList, AuthorList: response, searchText: searchText });
  };

  // const handleDatePicker = (e: any) => {
  //   if (e) {
  //     let response = handleDatePickersnotes(e, linkList);
  //     setlinkList({
  //       ...linkList,
  //       searchNotes: response
  //     });
  //   }
  // };

  const openCalender = (key: any, list?: any) => {
    if (key === "calender") {
      // setnotesList({ ...notesList, isCalender: true, filterKey: "calender" });
    } else if (key === "All") {
      let result: any = _(linkList.tempLinkList)
        .groupBy((o: any) => (o.timestamp &&
          moment(o.timestamp).format('DD MMM YYYY')))
        .map((contacts: any, letter: any) => ({ letter, contacts }))
        .value();
      setlinkList({ ...linkList, linkListArr: result, filterKey: "All", isVisible: false });
    } else {
      let date = new Date();
      let formatKey: any = key === "Today" ? moment(date).format('YYYY/MM/DD') : moment(date).subtract(1, 'day').format('YYYY/MM/DD');
      let response = _.filter(linkList.tempLinkList, ((data: any) => {
        let notesDate = moment(new Date(parseInt(data.timestamp))).format('YYYY/MM/DD');
        return notesDate === formatKey;
      }));
      let result: any = _(response)
        .groupBy((o: any) => (o.timestamp &&
          moment(o.timestamp).format('DD MMM YYYY')))
        .map((contacts: any, letter: any) => ({ letter, contacts }))
        .value();

      setlinkList({ ...linkList, linkListArr: result, filterKey: key, isVisible: false });
    }
  };

  const createNotes = (data: any) => {

    var parseData = data;
    let contact = data?.type === 1 ? data?.to : "con" + data?.chatId;
    let contactsDetail = getcontactDetail(contact);
    ChatService.saveChatHighlight(true, parseData);
    const socketservice = new SocketChatService(userdetails.sip_login_id, userdetails.domain_id);
    if (contactsDetail?.sip_login_id) {
      let chatDetail = { chatId: generateChatID(userInfo().fromID, contactsDetail.sip_login_id.toString()) };
      socketservice.openChatWindow(contactsDetail, "", chatDetail);
    } else {
      socketservice.openChatWindow(contactsDetail, "");
    }
    ChatService.openChatWindow(contactsDetail, "");

    // if (!chatReducer.isSaveChat) {
    //    props.handleRightWindow("savedchat");
    // }
  };


  const confirmDelete = (data: any) => {
    setlinkList({ ...linkList, deleteModelOpen: true, deletedData: data });
  };
  const closeSelection = () => {
    let deletedArray: any = [];
    store.dispatch({
      type: Types.SELECT_MESSAGE_ARRAY,
      payload: {
        selectMessageData: deletedArray
      }
    });
    setlinkList({ ...linkList, deleteModelOpen: false });
  };
  const handleChange = (flag: boolean) => {
    setlinkList({ ...linkList, isVisible: flag });
  }

  //let groupedArray = groupSavedChatbyday(linkList.searchLink);

  const menu = (
    <Menu className="rightdropactions2" >
      <Menu.Item className={linkList.filterKey === 'All' ?
        "active" : ''}>
        <div className={`notesdd ${styles.dropsdowns}`} >
          <div className={`searchnotes ${styles.innerlayerssearch}`}>
            <URInput placeHolder="Search" className="leftbarsearch notes" onChange={(e: any) => searchMember(e)} />
          </div>

          <div className="innerlayers scroller">
            {linkList?.searchText === "" && <> <h4>Date Created</h4>
              <ul className="datacreate">
                <li key={'All'} onClick={() => openCalender("All")}>All</li>
                <li key={'Today'} onClick={() => openCalender("Today")}>Today</li>
                <li key={'Yesterday'} onClick={() => openCalender("Yesterday")}>Yesterday</li>
                {/* <li key={'calender'} onClick={() => openCalender("calender")}>calender</li> */}
              </ul>
              <h4>Author</h4></>}
            <ul >
              {linkList?.AuthorList?.map((man: any) => {
                return (
                  <>
                    <li onClick={() => AuthorFilter(man)}>{man?.caller_id}</li>
                  </>

                );

              })
              }

            </ul>
          </div>
        </div>

      </Menu.Item>
    </Menu>
  );
  var len = Array.isArray(linkList.linkListArr) && linkList.linkListArr?.length > 7 ? Math.ceil((linkList.linkListArr?.length / 8)) : 1;
  var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  return (
    <>
      <div className={styles.linksSec} >
        <div className={styles.notessearchbar}>
          <div className={styles.lefts}>
            <Dropdown
              overlay={menu}
              trigger={['click']}
              visible={linkList.isVisible}
              onVisibleChange={handleChange}
              placement="bottomLeft">
              {/* <p>All<span className={`icon_down-arrow menudroprotate`}></span></p> */}
              <div className={`makeactive ${styles.drpDownsLinks}`} onClick={e => e.preventDefault()}>
                All<span className="icon_downarrow2"></span></div>
            </Dropdown>
          </div>
          <div className={styles.rights}>
            <URInput placeHolder="Search" className={`customFocused ${styles.rightbarsearch}`} onChange={(e: any) => searchKey(e)} />
          </div>
        </div>
        {linkList?.linkListArr?.length === 0 && isContactLink && <NoContent image={linkNoFound}
          title={"Worktual Links"}
          description={<>All your personal links reside here. Easily reference and
            <br /> check back at any time.</>} />}
        {!isContactLink && <Lottie className="svgLoading"
          animationData={ContactLoader} />}
        <div className={`scroller ${styles.linkslistScroll}`} onScroll={handleScroll}>
          {linkList.linkListArr && linkList.linkListArr.map((LinkListdetails: any, index: any) => {
            return (<>
              {/* <Divider plain className="dividerDate bgTransfont">	
                <HighlightInner content={getGroupDateFormat(LinkListdetails.letter)} searchedData={linkList.searchKey} />	
              </Divider> */}	
              <div className="dividercross topset">	
                <div className="dividerLineView">{getGroupDateFormat(LinkListdetails.letter)}</div>	
              </div>
              {LinkListdetails.contacts && LinkListdetails.contacts?.map((link: any, index: any) => {
                let isBookmark: any = link.message?.isSave || [];
                let LikeObeject: any = link?.message?.liked || [];
                let isLike = (LikeObeject && LikeObeject['s' + userdetails.sip_login_id]) || 0;
                let savedBookmark = (isBookmark && isBookmark['s' + userdetails.sip_login_id]) || 0;
                let currentDate = getTooltipTime(link?.timestamp);
                return (
                  <>

                    {/* <Affix offsetTop={81}>
                  <Divider plain className="dividerDate contactDivider">{group.date}</Divider>
                </Affix> */}
                    {/* {link?.messageArray?.map((save:any)=>{ */}
                    {/* if(save?.contactDetail?.team_id){
                    teamMemberarrayforImage = save?.contactDetail?.team_id && save?.contactDetail?.team_members &&
                  save?.contactDetail?.team_members.replaceAll(" ", "").split(',');
                    teamMemberarrayforImage?.map((list:any)=>{
                      let c_details = getcontactDetail(list);
                      teamMemberNames.push(c_details?.caller_id);
                    });
                  } */}



                    <></>
                    {link?.message?.messageType !== "FILE" && <div className={styles.linkslist} >
                      <div className={styles.toplayer}>
                        <div className={styles.profiles}>
                          {/* <URAvatarGroup className='lefts size28'
                              profileInfo={ <>
                                {link?.image &&
                                loginDetails?.userdetails?.caller_id !== link?.fromDetails?.caller_id   ?
                                  <img src={link?.image} alt="" />:
                                  loginDetails.userdetails.profile_url&&
                                  loginDetails?.userdetails?.caller_id === link?.fromDetails?.caller_id?
                                    <img src={loginDetails?.userdetails?.profile_url} alt="" />
                                    :<span>{link?.name?.charAt(0)?.toUpperCase()}</span> }
                                {loginDetails?.userdetails?.caller_id === link?.fromDetails?.caller_id?
                                  <URStatusDot
                                    className={userStatusColor(loginDetails?.userdetails?.user_status,'small')}/>:
                                  <URStatusDot className={userStatusColor(link?.presence,'small')}/>
                                }
                              </>  }
                            /> */}
                          <URAvatarGroup className={`lefts size28 colorBG${random_color[index]}`}
                            profileInfo={<>
                              {
                                link.fromDetails?.profile_image_thumbnail ?
                                  <img src={link.fromDetails?.profile_image_thumbnail} alt="" /> :
                                  link.fromDetails?.profile_url ?
                                    <img src={link.fromDetails?.profile_url} alt="" />
                                    : <span>{link.fromDetails?.caller_id?.charAt(0)?.toUpperCase()}</span>}

                              <URStatusDot className={userStatusColor(link.fromDetails?.user_status, 'small')} />


                            </>}
                          />
                        </div>
                        <h3>
                          <HighlightInner
                            content={userdetails?.caller_id
                              === link?.fromDetails?.caller_id ? "You" : link?.fromDetails?.caller_id ? link?.fromDetails?.caller_id : link?.fromDetails?.team_name ? link?.fromDetails?.team_name : "Unknown User"}
                            searchedData={linkList.searchKey} />
                          <span className={`icon_strokearrowright ${styles.arrowrightclr}`} ></span>


                          <b>
                            <HighlightInner content={userdetails?.caller_id
                              === link?.toDetails?.caller_id ? "You" : link?.toDetails?.caller_id ? link?.toDetails?.caller_id : link?.toDetails?.team_name ? link?.toDetails?.team_name : "Unknown User"}
                              searchedData={linkList.searchKey} />
                          </b>
                          

                          {/* <span className={styles.dates}>
                      {moment(link?.timestamp).format("D MMM")}</span> */}
                        </h3>
                        {/* <h3>{loginDetails?.userdetails?.caller_id === link?.fromDetails?.caller_id
                      ? "You" : link?.fromDetails?.team_id ?
                        link?.fromDetails?.team_name :
                        link?.fromDetails?.caller_id}
                      <span className="icon_strokearrowright"></span>
                      <b>{loginDetails?.userdetails?.caller_id === link?.toDetails?.caller_id
                        ? "You" : link?.toDetails.team_id ? link?.toDetails?.team_name :
                          link?.toDetails?.caller_id}
                      </b> <span className={styles.likeIcon}>
                        <ChatLike className='likeLeft likeSaved'
                          tooltipTitle={link?.likeduserdetails} message={link}
                        /></span> </h3> */}
                      </div>
                      <div className={styles.topbottomlayer}>
                        {/* <div className={styles.lefts}>
                          {savedBookmark === 1 ? <span className="icon_ribbon"></span> :
                            <span className="icon_linkrotate"></span>}
                          <Tooltip mouseEnterDelay={0.5} placement="top" title={currentDate} >
                            <span className={styles.chatTime}>
                              {moment(link?.timestamp).format('hh:mm')}
                            </span>
                          </Tooltip>
                        </div> */}

                          {link?.message?.messageType === "IMAGE" && link?.message?.isLink === true ?
                          <p className={styles.linkText} onClick={() => createNotes(link)}>
                            <HighlightInner content={link?.message?.body?.text} searchedData={linkList.searchKey} /> </p> :
                          <p className={styles.contentTxt} onClick={() => createNotes(link)} dangerouslySetInnerHTML={{ __html: urlify(link?.message?.body) }}>
                          </p>}

                        <div className={styles.hoverdiv}>
                          <ul>
                            <li onClick={() => copy(link)}>
                              <Tooltip mouseEnterDelay={0.5} placement="top" title="Copy to Clipboard">
                                <span className="icon_copydoc"></span></Tooltip></li>

                            <li onClick={() => likeCommonFunction(isLike === 0 ? 1 : 0, link)}><Tooltip mouseEnterDelay={0.5} placement="top"
                              title={isLike === 0 ? 'Like' : 'Unlike'}><span className="icon_Like"></span></Tooltip></li>

                            <li onClick={() => saveChatCommonFunction(savedBookmark === 0 ? 1 : 0, link)}><Tooltip mouseEnterDelay={0.5} placement="top"
                              title={savedBookmark === 0 ?
                                'Save link' : 'UnSave link'}>
                              <span className={savedBookmark === 0 ? "icon_ribbon" : "icon_savechatsill"}></span></Tooltip></li>
                            {link?.fromDetails?.sip_login_id === userdetails.sip_login_id &&
                              <li onClick={() => confirmDelete(link)}><Tooltip mouseEnterDelay={0.5} placement="top" title="Delete link">
                                <span className="icon_delete"></span></Tooltip></li>}
                          </ul>
                        </div>
                        
                      </div>
                      <div className="likeLeft">
                            <ChatLike className='likeRight likeSaved contmarnon' tooltipTitle={link?.likeduserdetails} message={link} />
                        </div>
                    </div>}
                  </>
                );

              })}
            </>
            );
          })}
          {isLinkChatLoad && ([1, 2, 3, 4, 5, 6].map((item: any, index: any) => (
            <URChatLeftSkeleton width={100} key={index} />)))}
        </div>

        {/*  <Affix offsetTop={81}>
          <Divider plain className="dividerDate contactDivider">Today</Divider>
        </Affix>
        <div className={styles.linkslist}>
          <div className={styles.toplayer}>
            <div className={styles.profiles}><span>D</span></div>
            <h3>You <span className="icon_strokearrowright"></span>
              <b>Diana Bailey</b> <span className={styles.likeIcon}>
                <ChatLike className='likeLeft likeSaved' tooltipTitle='Kyle Hill'/></span> </h3>
          </div>
          <div className={styles.topbottomlayer}>
            <div className={styles.lefts}>
              <span className="icon_linkrotate"></span>
              <Tooltip title='Today at 12:13 PM' className='cusTooltip'
                overlayClassName='customTooltip'><div className={styles.chatTime}>12:13</div></Tooltip>
            </div>
            <div className={styles.hoverdiv}>
              <ul>
                <li><Tooltip placement="top" title="Clip board"><span className="icon_copydoc"></span></Tooltip></li>
                <li><Tooltip placement="top" title="Like"><span className="icon_Like"></span></Tooltip></li>
                <li><Tooltip placement="top" title="Unsave chat"><span className="icon_ribbon"></span></Tooltip></li>
                <li><Tooltip placement="top" title="Delete"><span className="icon_delete"></span></Tooltip></li>
              </ul>
            </div>
            <p className={styles.linkText}>https://www.google.com/search?q=https+%2F%2Fcowin.gov.in&rlz=1C1GCEU_
            enIN968IN968&oq=https+%2F%2Fcowin.gov.in&aqs=chrome..
            69i57j0i433i512j0i512l8.1030j0j7&sourceid=chrome&ie=UTF-8</p>
          </div>
        </div>
        <Affix offsetTop={81}>
          <Divider plain className="dividerDate contactDivider">22 Aug at 5:20 AM</Divider>
        </Affix>
        <div className={styles.linkslist}>
          <div className={styles.toplayer}>
            <div className={styles.profiles}><span>D</span></div>
            <h3>You <span className="icon_strokearrowright"></span> <b>Diana Bailey
            </b> <span className={styles.likeIcon}>
              <ChatLike className='likeLeft likeSaved' tooltipTitle='Kyle Hill'/></span> </h3>
          </div>
          <div className={styles.topbottomlayer}>
            <div className={styles.lefts}>
              <span className="icon_linkrotate"></span>
              <Tooltip title='Today at 12:13 PM' className='cusTooltip'
                overlayClassName='customTooltip'><div className={styles.chatTime}>12:13</div></Tooltip>
            </div>
            <div className={styles.hoverdiv}>
              <ul>
                <li><Tooltip placement="top" title="Clip board"><span className="icon_copydoc"></span></Tooltip></li>
                <li><Tooltip placement="top" title="Like"><span className="icon_Like"></span></Tooltip></li>
                <li><Tooltip placement="top" title="Unsave chat"><span className="icon_ribbon"></span></Tooltip></li>
                <li><Tooltip placement="top" title="Delete"><span className="icon_delete"></span></Tooltip></li>
              </ul>
            </div>
            <p className={styles.linkText}>https://www.google.com/search?q=https+%2F%2Fcowin.gov.in
            &rlz=1C1GCEU_enIN968IN968&oq=https+%2F%2Fcowin.gov.in
            &aqs=chrome..69i57j0i433i512j0i512l8.1030j0j7&sourceid=chrome&ie=UTF-8</p>
          </div>
        </div> */}
      </div>
      <Modal title="Delete selected Link"
        centered
        visible={linkList.deleteModelOpen}
        onOk={() => deleteChat(linkList.deletedData)}
        onCancel={closeSelection}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected Link?
      </Modal>
    </>
  );
};
